import React from 'react';

/* TODO: Improve centering with flex */
function MetricsModalEmpty(_props) {
    return <div className="sch-metric-holder-empty color-grey">Sorry, no Metric found for given filter.</div>;
}

export default MetricsModalEmpty;
